import { Component } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import AxlButton from 'AxlMUIComponent/AxlButton';
import AxlInput from 'AxlMUIComponent/AxlInput';
import JDatePicker from 'components/JDatePicker';
import styles from './styles';

class PickupStatusFrom extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  save = (e) => {
    const { shipmentStore, shipment, pickup, closeForm } = this.props;
    this.setState({ error: null });
    shipmentStore.updatePickupStop(
      pickup,
      () => {
        closeForm();
      },
      (resp) => {
        if (resp.errors && resp.errors.length > 0) {
          this.setState({ error: resp.errors[0] });
        }
      },
    );
  };

  render() {
    const { shipment, dropoff, shipmentStore } = this.props;
    const { pickupStopForm } = shipmentStore;

    // console.log('actual ts is: ', pickupStopForm.actual_departure_ts);

    const stopStatuses = [
      { label: 'PENDING', value: 'PENDING', color: '#fa6725' },
      { label: 'SUCCEEDED', value: 'SUCCEEDED', color: '#4abc4e' },
      { label: 'FAILED', value: 'FAILED', color: '#d63031' },
    ];
    const pickupStatus = pickupStopForm.data.status ? { label: pickupStopForm.data.status, value: pickupStopForm.data.status } : null;
    const renderStatusInput = (params) => <TextField {...params} placeholder="Shipment Status" size="small" />;
    const pickupTimeOptions = {
      dateFormat: 'MMM DD, Y HH:mm:SS A',
      placeHolder: 'Pickup Time',
      enableTime: true,
      altInput: true,
      clickOpens: true,
      defaultValue: pickupStopForm.data.actual_departure_ts ? pickupStopForm.data.actual_departure_ts : null,
    };

    return (
      <div style={styles.Container}>
        <div style={styles.HeaderTitle}>{`Edit pickup remark`}</div>
        <Box>
          {this.state.error && (
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ flex: 1, ...styles.GroupPanel }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <span style={{ color: 'red', paddingLeft: '15px' }}>{this.state.error}</span>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{ flex: 1 }}>
                  <div style={styles.GroupTitle}>{`Pickup Status`}</div>
                  <div style={styles.Field}>
                    <Autocomplete
                      value={pickupStatus}
                      onChange={(_, newValue) => {
                        if (newValue) {
                          pickupStopForm.handlerReactSelect('status')(newValue);
                        }
                      }}
                      options={stopStatuses}
                      getOptionLabel={(option) => option.label || ''}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      renderInput={renderStatusInput}
                    />
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <div style={styles.GroupTitle}>{`Pickup Time`}</div>
              <div style={styles.GroupField}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <div style={styles.Field}>
                      <JDatePicker onChange={pickupStopForm.handlerDateInput('actual_departure_ts')} options={pickupTimeOptions} />
                    </div>
                  </Box>
                </Box>
              </div>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <div style={styles.GroupTitle}>{`Remark`}</div>
              <div style={styles.GroupField}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <div style={styles.Field}>
                      <AxlInput
                        value={pickupStopForm.getField('remark', '')}
                        onChange={pickupStopForm.handlerInput}
                        placeholder={`Remark`}
                        name={`remark`}
                        type={`text`}
                        fluid
                      />
                    </div>
                  </Box>
                </Box>
              </div>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton compact bg={`gray`} onClick={this.props.closeForm} style={styles.buttonControl}>{`Cancel`}</AxlButton>
                </div>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton
                    compact
                    bg={`pink`}
                    disabled={!pickupStopForm.data.actual_departure_ts}
                    onClick={this.save}
                    style={styles.buttonControl}
                  >{`Save`}</AxlButton>
                </div>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(PickupStatusFrom);
